import React from "react";
import useProductName from "brand-customization/useProductName";
import { licenseProductNames } from "license/helper/licenseProducts";
const ProductsCell = ({ products, licenseType }) => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, licenseProductNames({ products, license_type: licenseType }, productName).map((name) => /* @__PURE__ */ React.createElement("p", { key: name }, name)));
};
export default ProductsCell;
